import React, { useEffect, useMemo } from 'react';
import { UrlParam } from 'types/Misc';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Scrollbar from 'utils/Scrollbar';
import { useGlobal } from 'context/global/GlobalContext';
import LoadingIndicator from 'components/atomic/LoadingIndicator';
import HtmlWrapper from 'components/wrappers/HtmlWrapper';
import PageWrapper from 'components/layout/PageWrapper';
import { ExperienceData } from 'utils/linkTracking';

const GameRules: React.FC = () => {
  const {
    sweepstakesGameRules,
    gameRulesLoading,
    productDetails,
    setSlug,
    reFetchProduct,
    authFetched,
  } = useGlobal();
  const { t } = useTranslation('translation', { keyPrefix: 'gameRules' });
  const { id } = useParams<UrlParam>();

  useEffect(() => {
    if (id) setSlug(id);
  }, [id, setSlug]);

  // Fetch product details if missing (handles hard refresh scenario)
  useEffect(() => {
    if (authFetched && id && !productDetails) {
      reFetchProduct();
    }
  }, [authFetched, id, productDetails, reFetchProduct]);

  const experienceData: ExperienceData | null = useMemo(() => {
    if (!productDetails?.product) return null;
    return {
      id:
        productDetails.product?.experienceDetails?.experienceBrijID ||
        productDetails.product?.id ||
        '',
      name: productDetails.product?.name || '',
      title:
        productDetails.product?.displayName ||
        productDetails.product?.name ||
        '',
    };
  }, [productDetails?.product]);

  return (
    <PageWrapper
      allowGoBack={productDetails ? true : false}
      pageTitle={t('pageHeaderTitle')}
    >
      <Helmet>
        <title>{t('pageTitle')}</title>
      </Helmet>
      {gameRulesLoading ? (
        <div className='relative w-full h-full flex items-center justify-center pb-16'>
          <LoadingIndicator />
        </div>
      ) : (
        <Scrollbar style={{ background: '#FFFFFF' }}>
          <div className='relative w-full h-full px-5 pt-3 pb-4'>
            <HtmlWrapper
              html={sweepstakesGameRules?.gamerules || ''}
              linkTrackingParams={
                productDetails?.product?.linkTrackingParams || null
              }
              experienceData={experienceData}
            />
          </div>
        </Scrollbar>
      )}
    </PageWrapper>
  );
};

export default GameRules;
